import { useEffect, useState } from 'react';
import { parse } from 'yaml';

// CRAではimport.meta.globが使えないため、ファイル名を明示的にリスト化
const SEQUENCE_FILES = [
    'pronunciation_sentence.yaml',
    'pronunciation_sentence_slow.yaml',
    'lesson_result_pass.yaml',
    'lesson_result_fail.yaml',
    'lesson_result_detail.yaml',
    'lesson_result_error.yaml'
];
export function useSequences() {
    const [sequences, setSequences] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let mounted = true;
        const load = async () => {
            setLoading(true);
            const loaded = [];
            const errors = [];
            await Promise.all(SEQUENCE_FILES.map(async (filename) => {
                const path = `${process.env.PUBLIC_URL}/sequences/${filename}`;
                try {
                    const response = await fetch(path);
                    if (!response.ok) {
                        errors.push(`シーケンスファイルの読み込みに失敗しました: ${filename}`);
                        return;
                    }
                    const content = await response.text();
                    const parsed = parse(content);
                    if (!parsed || typeof parsed !== 'object') {
                        errors.push(`シーケンスの読み込みに失敗しました: ${path}`);
                        return;
                }
                if (!parsed.name) {
                    errors.push(`必須項目(name)が不足しているためスキップ: ${path}`);
                    return;
                }
                // audioFileは任意（無音シーケンスを許容）
                const events = Array.isArray(parsed.events) ? parsed.events : [];
                const audioFileExplicit = Object.prototype.hasOwnProperty.call(parsed, 'audioFile');
                loaded.push({
                    ...parsed,
                    id: parsed.id ?? parsed.name,
                    name: parsed.name,
                    audioFileExplicit,
                    audioFile: parsed.audioFile,
                    events
                });
            }
            catch (err) {
                    console.error(`シーケンス定義のパースに失敗しました: ${path}`, err);
                    errors.push(`シーケンス定義のパースに失敗しました: ${path}`);
                }
            }));
            if (!mounted)
                return;
            loaded.sort((a, b) => a.name.localeCompare(b.name, 'ja'));
            setSequences(loaded);
            setError(errors.join('\n'));
            setLoading(false);
        };
        load();
        return () => {
            mounted = false;
        };
    }, []);
    return { sequences, error, loading };
}
